import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import { HYDRATE } from 'next-redux-wrapper';

import type { HydrateAction } from '../../index';
import type { ILandingState } from './types';

export const initialState: ILandingState = {
  data: null,
};

export const LandingsSlice = createSlice({
  name: 'landings',
  initialState,
  reducers: {
    setData(state, { payload }: PayloadAction<ILandingState['data']>) {
      state.data = payload;
    },
  },
  extraReducers: builder => {
    builder.addCase(HYDRATE, (state, action: HydrateAction<ILandingState>) => {
      return action.payload.landings;
    });
  },
});

export const { actions: LandingsActions } = LandingsSlice;

export default LandingsSlice.reducer;
